export default "__VITE_ASSET__kVkFIjGS__"